//import React from 'react';
import { connect } from 'react-redux';
import CoverLetter from '../components/CoverLetter';
import { getDateTime } from '../helper';
import { saveCoverLetter, savePreviewCoverLetter, saveCoverLetterQA, loadCoverletterQA, createCoverLetter } from '../services/actions/actions';
import Cookie from 'js-cookie';
import { COOKIE_DOMAIN } from '../constants/constants';
import WpAPI from '../WpApi';

const mapStateToProps = (state, ownProps) => {
    // const { resume, available_steps } = state;
    return { ...state.coverletter }
};

const mapDispatchToProps = dispatch => {
    return { handlers:{
        save: () => dispatch(saveCoverLetter({ modified_date: getDateTime() }, true)),
        update2Preview: (data, saveit = false) => dispatch(savePreviewCoverLetter({...data}, saveit)),
        saveQA: (data) => dispatch(saveCoverLetterQA(data)),
        loadQA: () => dispatch(loadCoverletterQA()),
        createCoverLetter: () => dispatch(createCoverLetter()),
        editInProgress: () =>  Cookie.get('current_letter', {domain: COOKIE_DOMAIN, path: "/"}) ? true : false,
        loadLetter: (callback=null) => WpAPI.fetchActiveLetter(dispatch,callback)
        }
    }
};

const CoverLetterContainer = connect(mapStateToProps, mapDispatchToProps)(CoverLetter);
export default CoverLetterContainer;
